var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-list',[_c('md-list-item',{attrs:{"to":{ name: 'Home' }},on:{"click":function($event){return _vm.hide()}}},[_vm._v(" "+_vm._s(_vm.$t("home"))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }